<template>
  <div class="flex min-h-dvh max-h-dvh flex-col overflow-hidden bg-white">
    <Navbar v-if="userStore.user" />
    <BasicNavbar v-else show-cta />
    <slot />
  </div>
</template>

<script setup lang="ts">
import Navbar from '@/shared/components/Navbar.vue'
import BasicNavbar from '@/shared/components/BasicNavbar.vue'
import { useUserStore } from '@/shared/stores/user'

const userStore = useUserStore()
</script>
